import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/search.svg'
import _imports_1 from '@/assets/images/nodata.png'
import _imports_2 from '@/assets/images/nodata@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-70146c6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_2 + ' 2x'
const _hoisted_2 = { action: "\n" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "search-logo",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "tip" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 搜索到与“")
const _hoisted_6 = { class: "blue" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("”相关信息共")
const _hoisted_8 = { class: "blue" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("条 ")
const _hoisted_10 = {
  key: 1,
  class: "nodata"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  srcset: _hoisted_1,
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "暂无相关数据", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_skeleton = _resolveComponent("van-skeleton")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", _hoisted_2, [
      _createVNode(_component_van_search, {
        modelValue: _ctx.keyword,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
        placeholder: "输入您的问题",
        shape: "round",
        background: "#0F1423",
        onSearch: _ctx.searchEnter
      }, {
        "left-icon": _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["modelValue", "onSearch"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.relate), 1),
      _hoisted_7,
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.total), 1),
      _hoisted_9
    ]),
    (_ctx.searchLoading)
      ? (_openBlock(), _createBlock(_component_van_skeleton, {
          key: 0,
          title: "",
          row: 18
        }))
      : _createCommentVNode("", true),
    (_ctx.total === 0 && !_ctx.searchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
      : _createCommentVNode("", true),
    (_ctx.total !== 0 && !_ctx.searchLoading)
      ? (_openBlock(), _createBlock(_component_van_list, {
          key: 2,
          loading: _ctx.listLoading,
          "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listLoading) = $event)),
          finished: _ctx.finished,
          "finished-text": "没有更多了",
          onLoad: _ctx.onLoad,
          offset: "20"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "result",
                key: item.questionId,
                onClick: _withModifiers(($event: any) => (_ctx.toQuestion(item)), ["stop"])
              }, [
                _createElementVNode("div", {
                  class: "question",
                  innerHTML: item.question
                }, null, 8, _hoisted_15),
                _createElementVNode("div", {
                  class: "answer",
                  innerHTML: item.newAnswer
                }, null, 8, _hoisted_16),
                _hoisted_17
              ], 8, _hoisted_14))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"]))
      : _createCommentVNode("", true)
  ], 64))
}